<template>
  <OmtLayoutContainer>
    <OmtRow mb="24px" v-for="({ handle, ...item }, index) in menu" :key="index">
      <CardTile v-bind="item" @click="handle" />
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import CardTile from "@/components/Molecules/CardTile";

export default {
  components: {
    CardTile
  },
  data() {
    return {
      menu: [
        {
          icon: {
            name: "flask",
            size: "sm"
          },
          title: "Simulação de exames",
          description: "Confira as estimativas de custos de exames em diferentes prestadores da rede credenciada",
          handle: () => {
            this.$router.push({
              path: "/copay/simulations"
            });
          }
        },
        {
          icon: {
            name: "memo",
            size: "sm"
          },
          title: "Modelo de coparticipação",
          description: "Veja as informações detalhadas sobre o modelo de coparticipação do seu plano",
          handle: () => {
            this.$router.push({
              path: "/copay/models"
            });
          }
        }
      ]
    };
  },
  mounted() {
    this.$root.$emit("hide-loading");
  }
};
</script>
